import { render, staticRenderFns } from "./AddInfoBus.vue?vue&type=template&id=50e1db79&scoped=true&"
import script from "./AddInfoBus.vue?vue&type=script&lang=js&"
export * from "./AddInfoBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1db79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
